'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TemplateBoldIcon = function TemplateBoldIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 18.2 13' }, props),
        _react2.default.createElement('path', { 'class': 'cls-1', d: 'M5.61 13H2.12A2.12 2.12 0 0 1 0 10.88V3h5.61zM18.2 2.12A2.18 2.18 0 0 0 16 0H2.23A2.18 2.18 0 0 0 0 2.12zM6.47 3v10h9.61a2.12 2.12 0 0 0 2.12-2.12V3zM7.8 5.65a.45.45 0 0 1 .45-.45h5.34a.45.45 0 0 1 .45.45v.14a.45.45 0 0 1-.45.45H8.25a.45.45 0 0 1-.45-.45zM14 10a.45.45 0 0 1-.45.45h-5.3A.45.45 0 0 1 7.8 10v-.19a.45.45 0 0 1 .45-.45h5.34a.45.45 0 0 1 .45.45zm1.6-1.68H8.32a.52.52 0 0 1 0-1h7.28a.52.52 0 0 1 0 1z' })
    );
};

exports.default = TemplateBoldIcon;